export type DashboardTab = { value: string; slug: string; label: string };
export type DashboardGroup = { id: string; label: string; tabs: DashboardTab[] };

export const dashboardGroups: DashboardGroup[] = [
  { id: "overview", label: "Översikt", tabs: [
    { value: "19", slug: "overview", label: "Överblick" },
    { value: "1", slug: "labels", label: "Etiketter" },
  ] },
  { id: "planning", label: "Planering", tabs: [
    { value: "17", slug: "weekly-orders", label: "Veckobeställningar" },
    { value: "16", slug: "weekly-distribution", label: "Veckofördelning" },
  ] },
  { id: "fresh", label: "Färskt", tabs: [
    { value: "11", slug: "products", label: "Produkter" },
    { value: "13", slug: "batches", label: "Batcher" },
    { value: "12", slug: "packages", label: "Förpackningar" },
    { value: "14", slug: "stock", label: "Lager" },
  ] },
  { id: "processed", label: "Processat", tabs: [
    { value: "9", slug: "batches", label: "Batcher" },
    { value: "20", slug: "products", label: "Produkter" },
    { value: "10", slug: "packages", label: "Förpackningar" },
    { value: "18", slug: "stock", label: "Lager" },
  ] },
  { id: "webshop", label: "Webshop", tabs: [
    { value: "22", slug: "overview", label: "Översikt" },
    { value: "23", slug: "catalog", label: "Sortiment" },
    { value: "24", slug: "orders", label: "Ordrar" },
    { value: "25", slug: "fulfilment", label: "Packning och frakt" },
    { value: "26", slug: "inventory", label: "Säljbarhet" },
    { value: "27", slug: "support", label: "Kundärenden" },
    { value: "28", slug: "withdrawals", label: "Ångrade köp" },
    { value: "29", slug: "shipping", label: "Frakt" },
    { value: "21", slug: "settings", label: "Inställningar" },
  ] },
  { id: "operations", label: "Verksamhet", tabs: [
    { value: "15", slug: "customers", label: "Kunder" },
    { value: "5", slug: "self-checks", label: "Egenkontroll" },
    { value: "7", slug: "documentation", label: "Dokumentation" },
  ] },
];

export const dashboardPath = (group: DashboardGroup, tab: DashboardTab) => `/${group.id}/${tab.slug}`;
export const DEFAULT_DASHBOARD_PATH = dashboardPath(dashboardGroups[0], dashboardGroups[0].tabs[0]);

export function dashboardTabForPath(pathname: string): { group: DashboardGroup; tab: DashboardTab } | null {
  for (const group of dashboardGroups) {
    const tab = group.tabs.find((item) => dashboardPath(group, item) === pathname);
    if (tab) return { group, tab };
  }
  const detail = /^\/webshop\/(orders|support|withdrawals)\/([^/]+)$/.exec(pathname);
  if (detail) {
    const group = dashboardGroups.find((item) => item.id === "webshop")!;
    return { group, tab: group.tabs.find((item) => item.slug === detail[1])! };
  }
  return null;
}

export function isDashboardPath(pathname: string): boolean {
  return dashboardTabForPath(pathname) !== null;
}

export function dashboardFallbackPath(pathname: string): string {
  const group = dashboardGroups.find((item) => pathname === `/${item.id}` || pathname.startsWith(`/${item.id}/`));
  return group ? dashboardPath(group, group.tabs[0]) : DEFAULT_DASHBOARD_PATH;
}

export function dashboardReturnPath(value: unknown): string {
  return typeof value === "string" && isDashboardPath(value) ? value : DEFAULT_DASHBOARD_PATH;
}
